import React from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0B0F19",
        color: "#ffffff",
        paddingTop: "100px",
        paddingBottom: "60px",
        textAlign: "center",
        position: "relative",
      }}
    >
      <Container maxWidth="sm">
        <img
          src="https://ik.imagekit.io/urhub/assets/404-not-found.png"
          alt="404 Not Found"
          style={{
            maxHeight: "260px",
            width: "auto",
            marginBottom: "32px",
            filter: "drop-shadow(0 15px 30px rgba(222, 20, 140, 0.3))",
          }}
        />

        <Typography
          variant="h2"
          style={{
            fontWeight: 800,
            fontSize: "clamp(1.8rem, 3.5vw, 2.5rem)",
            marginBottom: "12px",
          }}
        >
          Halaman Tidak Ditemukan
        </Typography>

        <p
          style={{
            color: "#94a3b8",
            fontSize: "16px",
            lineHeight: 1.6,
            marginBottom: "32px",
          }}
        >
          Halaman yang Anda tuju tidak tersedia atau telah dipindahkan. Silakan kembali ke halaman utama kami.
        </p>

        <Button
          component={Link}
          to="/"
          variant="contained"
          style={{
            background: "linear-gradient(135deg, #DE148C 0%, #B8096F 100%)",
            color: "#ffffff",
            fontWeight: 700,
            fontSize: "15px",
            padding: "12px 32px",
            borderRadius: "9999px",
            textTransform: "none",
            boxShadow: "0 8px 25px -2px rgba(222, 20, 140, 0.45)",
          }}
        >
          ← Kembali ke Beranda
        </Button>
      </Container>
    </div>
  );
}
